import React from 'react'
import {
  SkillTab_for_original_selectBodyMessage, 
  SkillTab_for_head_coding, 
  SkillTab_for_rightArm_frontEnd, 
  SkillTab_for_leftArm_backEnd,
  SkillTab_for_chest_database,
  SkillTab_for_pack_webHelpingTools,
  SkillTab_for_undi_forbiddenPart,
  SkillTab_for_leg_otherSkills,
  SkillTab_for_whole_allSkills

} from './SkillsTabs_components/SkillTab_for_Coding'
import './SkillsInfoModal.css'

const SkillTab = (props) => {
    return (
      <div className='skillTab-wrapper'>
        {props.skillTab === 'original' ? (
          <div>
            <SkillTab_for_original_selectBodyMessage />
          </div>
        ) : null}
        {props.skillTab === "head" ? (
          <div>
            <SkillTab_for_head_coding />
          </div>
        ) : null}
        {props.skillTab === 'rightArm' ? (
          <div>
            <SkillTab_for_rightArm_frontEnd />
          </div>
        ) : null}
        {props.skillTab === 'leftArm' ? (
          <div>
            <SkillTab_for_leftArm_backEnd />
          </div>
        ) : null}
        {props.skillTab === 'chest' ? (
          <div>
            <SkillTab_for_chest_database />
          </div>
        ) : null}
        {props.skillTab === 'pack' ? (
          <div>
            <SkillTab_for_pack_webHelpingTools />
          </div>
        ) : null}
        {props.skillTab === 'undi' ? (
          <div>
            <SkillTab_for_undi_forbiddenPart />
          </div>
        ) : null}
        {props.skillTab === 'leg' ? (
          <div>
            <SkillTab_for_leg_otherSkills />
          </div>
        ) : null}
        {props.skillTab === 'whole' ? (
          <div>
            <SkillTab_for_whole_allSkills />
          </div>
        ) : null}
      </div>
    );
}

export default SkillTab;
